import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";
import { Dataset } from "./dataset";
import { User } from "../../users/_types/user";
import { Group } from "../../groups/_types/group";

export class ReportUserGroupPermission extends Resource {
    public override type = 'reportUserGroupPermissions';      
    
    @prop()
    @required()
    public reportId!: string;        
        
    @prop()    
    public userId!: string;
    
    public user!: User;

    @prop()    
    public groupId!: string;
    
    public group!: Group;
    
    @prop()
    @required()
    public allowRead: boolean = true;
    
    @prop()
    @required()
    public allowWrite: boolean = true;
    
}